module.exports = __webpack_public_path__ + "images/4b96fb1.png";